<template>
  <section class="stats">
    <div class="stats-inner">
      <div v-for="(s, i) in stats" :key="i" class="stat">
        <div class="stat-num">
          <span class="num">{{ s.num }}</span>
          <span class="unit">{{ s.unit }}</span>
        </div>
        <div class="stat-label">{{ s.label }}</div>
      </div>
    </div>
  </section>
</template>

<script setup>
const stats = [
  { num: "15+", unit: "年", label: "制造加工经验" },
  { num: "4", unit: "大品类", label: "家电 / 照明 / 塑料 / 五金" },
  { num: "2", unit: "条主线", label: "制造加工 + 进出口贸易" },
  { num: "7×24", unit: "h", label: "响应客户合作需求" },
];
</script>

<style scoped>
.stats {
  background: linear-gradient(120deg, #0a4f97 0%, #0b66bb 55%, #0e7fc9 100%);
  position: relative;
  z-index: 3;
  margin-top: -1px;
}

.stats-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 34px 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.stat {
  text-align: center;
  color: #fff;
  padding: 6px 8px;
}

.stat-num {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  margin-bottom: 6px;
}

.num {
  font-size: 36px;
  font-weight: 800;
  line-height: 1;
  color: #ffc53d;
}

.unit {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
}

.stat-label {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.82);
  letter-spacing: 0.5px;
}

@media (max-width: 760px) {
  .stats-inner {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }

  .num {
    font-size: 30px;
  }
}
</style>
